import styled from 'styled-components';
import { getColorShade, getSizeBy, getThemeProp } from '../../../../../src/styled/utils';
import { disabledDropzoneCSS, hintBorderDropzoneCSS, dragActiveDropzoneCSS, dragRejectedCSS, focusedDropzoneCSS, defaultDropzoneCSS } from '../styled';
export const MultiDropzone = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${getSizeBy(6)} ${getSizeBy(3)};
  border: 1px dashed ${getColorShade('onSurface', 'outline')};
  border-radius: ${getThemeProp('borderRadius')}px;
  outline: none;
  ${defaultDropzoneCSS};

  &:hover {
    background-color: ${getColorShade('primary', 'hover')};
    border-color: ${({ disabled }) => !disabled && getColorShade('onSurface', 'lowEmphasis')};
  }

  ${({ isFocused, isDragActive, isDragReject, disabled, hintType }) => {
    if (disabled) {
        return disabledDropzoneCSS;
    }
    if (hintType && hintType !== 'info') {
        return hintBorderDropzoneCSS;
    }
    if (isDragReject) {
        return dragRejectedCSS;
    }
    if (isDragActive) {
        return dragActiveDropzoneCSS;
    }
    if (isFocused) {
        return focusedDropzoneCSS;
    }
}}
`;
